<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      :acesso-disable="acessoDisable"
      :footer-props="{
        'items-per-page-text': 'Linhas por página',
        'page-text': '{0}-{1} de {2}',
        'items-per-page-all-text': 'Todos',
      }"
      :items-per-page="5"
    >
      <template #[`item.nome`]="{ item }">
        <router-link
          :to="{ name: 'equipe', params: { id: item.equipeId }}"
          class="text--primary text-truncate cursor-pointer text-decoration-none"
        >
      
      
        <v-list-item class="ml-n4">
          <div class="d-flex align-center">
            <v-avatar
              :color="`${$vuetify.theme.dark ? 'primary' : '#DCDCDC'}`"
              size="32"
            >
              <span
                :class="`${$vuetify.theme.dark ? 'white--text' : 'primary--text'} font-weight-bold
              `"
              >
                {{ item.equipeNome.toUpperCase().charAt(0) }}
              </span>
            </v-avatar>
            <div class="d-flex flex-column ms-3 text-capitalize">
              {{ item.equipeNome }}
            </div>
          </div>
        </v-list-item>
      </router-link>
      </template>

      <template
        #[`item.descricao`]="{ item }"
      >
        <v-list-item>
          <div class="d-flex justify-center ml-n3 text-capitalize">
            {{ item.equipeDescricao }}
          </div>
        </v-list-item>
      </template>

      <template #[`item.ativo`]="{ item }">
        <v-chip
          class="v-chip-light-bg font-weight-semibold text-capitalize"
          small
          :class="`${item.ativa ? 'success--text' : 'secondary--text'}`"
          :color="`${item.ativa ? 'success' : 'secondary'}`"
        >
          {{ item.ativa ? "Ativa" : "Inativa" }}
        </v-chip>
      </template>

      <template #[`item.actions`]="{ item }">
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              class="ml-n5"
              v-on="on"
              color="primary"
            >
              <v-icon @click="ativarOuInativarAssociacaoItem(item)">
                {{ icons.mdiDotsVertical }}
              </v-icon>
            </v-btn>
          </template>
          <v-list
            v-if="acessoDisable"
          >
            <v-list-item>
              <v-list-item-title
                role="button"
                class="d-flex align-end"
                @click="openAssociarOuDesassociar"
              >
                <v-icon
                  size="20"
                  class="mr-1"
                >
                  {{ isAssociacaoAtiva ? icons.mdiCloseThick : icons.mdiCheckBold }}
                </v-icon>
                <span class="text-capitalize"> {{ isAssociacaoAtivaMensagem }} </span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>

    <!-- dialog -->
    <v-dialog
      v-model="dialogDesassociar"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-card-title class="headline text-capitalize">
          {{ isAssociacaoAtivaMensagem }}
        </v-card-title>
        <v-card-text>
          {{ `Tem certeza que vai ${isAssociacaoAtivaMensagem} a associação?` }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            outlined
            @click="closeAssociarOuDesassociar"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            @click="confirmarAtivacaoOuInativacaoDaAssociacao"
          >
            <v-progress-circular
              v-if="loading"
              indeterminate
              color="secundary"
            ></v-progress-circular>
            <span v-else>OK</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import { mdiCheckBold, mdiCloseThick, mdiDotsVertical } from '@mdi/js'
import FilaService from '@/services/modules/FilaService'
import router from '@/router';

export default {
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    acessoDisable: {
      type: Boolean,
      default: true,
    },
  },

  setup(props, { emit }) {
    const dialogDesassociar = ref(false)
    const loading = ref(false)
    const filaId = ref(0)
    const equipeId = ref(0)
    const isAssociacaoAtiva = ref(undefined)
    const isAssociacaoAtivaMensagem = ref('')

    const ativarOuInativarAssociacaoItem = item => {
      filaId.value = item.filaId
      equipeId.value = item.equipeId
      isAssociacaoAtiva.value = item.ativa
      isAssociacaoAtivaMensagem.value = item.ativa ? 'inativar' : 'ativar'
    }
    const openAssociarOuDesassociar = () => {
      dialogDesassociar.value = true
    }
    const closeAssociarOuDesassociar = () => {
      dialogDesassociar.value = false
    }
    const confirmarAtivacaoOuInativacaoDaAssociacao = async () => {
      loading.value = true

      await FilaService.ativarOuInativarFilaEquipe(filaId.value, equipeId.value, {
        ativar: !isAssociacaoAtiva.value,
      })

      emit('refetch-data')

      closeAssociarOuDesassociar()
      loading.value = false
    }

    return {
      dialogDesassociar,
      loading,
      filaId,
      equipeId,
      isAssociacaoAtiva,
      isAssociacaoAtivaMensagem,
      ativarOuInativarAssociacaoItem,
      openAssociarOuDesassociar,
      closeAssociarOuDesassociar,
      confirmarAtivacaoOuInativacaoDaAssociacao,
      icons: {
        mdiCheckBold,
        mdiCloseThick,
        mdiDotsVertical,
      },
      headers: [
        { text: 'NOME', value: 'nome' },
        { text: 'DESCRICAO', value: 'descricao' },
        { text: 'STATUS', value: 'ativo' },
        {
          text: 'OPÇÔES',
          value: 'actions',
          align: 'center',
        },
      ],
    }
  },
}
</script>
